import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-simple-table',
  templateUrl: './simple-table.component.html',
  styleUrls: ['./simple-table.component.css']
})
export class SimpleTableComponent implements OnInit {

  @Input() tableColumnsData: {}[];
  @Input() tableData: {}[];
  @Input() isFilterAvailable: boolean = true;

  pageSizeOptions = [];

  tableDataSrc: any;

  displayColumns: string[] = [];

  @ViewChild(MatPaginator, { static: false })
  set paginator(value: MatPaginator) {
    this.tableDataSrc.paginator = value;
  }

  constructor() { }

  ngOnInit(): void {
    this.tableColumnsData.forEach((ele: any) => {
      this.displayColumns.push(ele.columnName)
    })

    this.tableDataSrc = new MatTableDataSource(this.tableData);
    this.tableDataSrc.paginator = this.paginator;
  }

  ngOnChanges() {
    this.tableDataSrc = new MatTableDataSource(this.tableData);
  }

  applyFilter(event: any) {
    const filterTarget = event.target.value;
    this.tableDataSrc.filter = filterTarget.trim().toLowerCase();
  }

}
